import React from "react";
import PropTypes from "prop-types";

const imageStyle = { width: "100%", aspectRatio: "16/9", objectFit: "contain", display: "block" };

const ImageGrid = ({ items, selectedId, hoveredId, onHover, onLeave, onClick, getId, getUrl, getAlt, renderOverlay }) => {
    return (
        <div style={{ display: "flex", flexWrap: "wrap", gap: "1vh", maxHeight: "30vh", overflowY: "auto" }}>
            {items?.map((item) => {
                const id = getId(item);
                const isSelected = selectedId === id;
                const isHovered = hoveredId === id;
                const borderStyle = isSelected
                    ? "0.25vh solid #429fc2"
                    : isHovered
                        ? "0.25vh solid #429fc280"
                        : "0.25vh solid transparent";
                return (
                    <div
                        key={id}
                        role="button"
                        tabIndex={0}
                        className="pointer"
                        onMouseEnter={() => onHover(id)}
                        onMouseLeave={onLeave}
                        onClick={() => onClick(id)}
                        onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onClick(id); } }}
                        style={{
                            position: "relative",
                            width: "45%",
                            marginBottom: "1vh",
                            border: borderStyle,
                            borderRadius: "0.5vh",
                        }}
                    >
                        <img src={getUrl(item)} alt={getAlt(item)} style={imageStyle} />
                        {renderOverlay(item, isSelected, isHovered)}
                    </div>
                );
            })}
        </div>
    );
};

ImageGrid.propTypes = {
    items: PropTypes.array,
    selectedId: PropTypes.any,
    hoveredId: PropTypes.any,
    onHover: PropTypes.func.isRequired,
    onLeave: PropTypes.func.isRequired,
    onClick: PropTypes.func.isRequired,
    getId: PropTypes.func.isRequired,
    getUrl: PropTypes.func.isRequired,
    getAlt: PropTypes.func.isRequired,
    renderOverlay: PropTypes.func.isRequired,
};

export default ImageGrid;
